import USER_ROLE from 'constants/role';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import { selectAccessIds, selectManageIds } from 'utils/cognito.util';
import parseJson from 'utils/parsers/parseJson';

const selectUserRoleFromLogin = (state) => {
  const salonId = selectCurrentSalonId(state);

  if ((parseJson(selectManageIds(state)) || []).includes(salonId)) {
    return USER_ROLE.manager;
  }

  if ((parseJson(selectAccessIds(state)) || []).includes(salonId)) {
    return USER_ROLE.receptionist;
  }

  return null;
};

export default selectUserRoleFromLogin;
